import aHttp from '@/models/axiosConfig/aHttp';
import constants from '@/constants';
const {
  API_LIST: { EMTCSLP_EXTERNAL_APIGATEWAY_PROD }
} = constants;

const urls = {
  createPurchase: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/createPurchase`, // Creation of a document
  setDeliveryAddr: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/setDeliveryAddr`, // Get freight
  getAvailableWeChatPaymentPromotionCoupon: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/wechatpay/getAvailableWeChatPaymentPromotionCoupon`, // Get coupon list
  getCustomerConsent: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/customer/getCustomerConsent`,
  setCustomerConsents: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/customer/setCustomerConsents`,
  getKYCInfoListByPaymentInstrumentId: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/getKYCInfoListByPaymentInstrumentId`, // Get subscriber information
  createAndMapNewKYCCollectionToPaymentIntrument: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/createAndMapNewKYCCollectionToPaymentIntrument`, // Create subscriber information
  setMultipleAttributes: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/setMultipleAttributes`, // Rebuild & refresh purchase PCE document after updating KYC information
  getCustomerActualPurchase: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/customer/getCustomerActualPurchase`, //
  prepay: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/wechatpay/prepay`,
  queryPay: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/wechatpay/queryPay`,
  signPurchaseV2: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/signPurchaseV2`,
  uploadKYCImages: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/orders/uploadKycDocument`,
  createKYCCollection: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/kyc/createKYCCollection`,
  updateKYCCollection: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/kyc/updateKYCCollection`,
  removeKYCCollection: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/kyc/removeKYCCollection`,
  getKYCListByCustomerId: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/kyc/getKYCListByCustomerId`,
  createAndMapNewKYCCollectionToPaymentInstrument: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/kyc/createAndMapNewKYCCollectionToPaymentInstrument`,
  mapExistingKYCCollectionToPaymentInstrument: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/kyc/mapExistingKYCCollectionToPaymentInstrument`,
  createAndMapNewKYCCollectionToOrderAndAddress: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/kyc/createAndMapNewKYCCollectionToOrderAndAddress`,
  mapExistingKYCCollectionToOrderAndAddress: `${EMTCSLP_EXTERNAL_APIGATEWAY_PROD}/kyc/mapExistingKYCCollectionToOrderAndAddress`
};
export const createPurchase = params => aHttp.post(urls.createPurchase, params);
export const setDeliveryAddr = params =>
  aHttp.post(urls.setDeliveryAddr, params);
export const getAvailableWeChatPaymentPromotionCoupon = params =>
  aHttp.post(urls.getAvailableWeChatPaymentPromotionCoupon, params);
export const getCustomerConsent = params =>
  aHttp.get(urls.getCustomerConsent, params);
export const setCustomerConsents = params =>
  aHttp.post(urls.setCustomerConsents, params);
export const getKYCInfoListByPaymentInstrumentId = params =>
  aHttp.get(urls.getKYCInfoListByPaymentInstrumentId, params);
export const setMultipleAttributes = params =>
  aHttp.post(urls.setMultipleAttributes, params);
export const createNewKYC = params =>
  aHttp.post(urls.createAndMapNewKYCCollectionToPaymentIntrument, params);
export const getCustomerActualPurchase = params =>
  aHttp.get(urls.getCustomerActualPurchase, params);
export const prepay = params => aHttp.post(urls.prepay, params);
export const queryPay = params => aHttp.get(urls.queryPay, params);
export const signPurchaseV2 = params => aHttp.post(urls.signPurchaseV2, params);
export const getKYCListByCustomerId = params =>
  aHttp.get(urls.getKYCListByCustomerId, params);
export const removeKYCCollection = params =>
  aHttp.post(urls.removeKYCCollection, params);
export const uploadKYCImages = params =>
  aHttp.post(urls.uploadKYCImages, params);
export const createKYCCollection = params =>
  aHttp.post(urls.createKYCCollection, params);
export const createKYCToPaymentInstrument = params =>
  aHttp.post(urls.createAndMapNewKYCCollectionToPaymentInstrument, params);
export const updateKYCCollection = params =>
  aHttp.post(urls.updateKYCCollection, params);
export const syncKYCToPaymentInstrument = params =>
  aHttp.post(urls.mapExistingKYCCollectionToPaymentInstrument, params);
export const createKYCToOrder = params =>
  aHttp.post(urls.createAndMapNewKYCCollectionToOrderAndAddress, params);
export const syncKYCToOrder = params =>
  aHttp.post(urls.mapExistingKYCCollectionToOrderAndAddress, params);
